import React from "react";
import { CreditCard, Smartphone } from "lucide-react";
import qr from "../../assets/icons/qr.png";
import styles from "./Registration.module.css";

export default function Registration() {
  return (
    <div className={styles.page}>
      <div className={styles.container}>

        <header className={styles.heroSection}>
          <h1 className={styles.Title}>Registration</h1>
          <p className={styles.sectionSubtitle}>
            Register now and secure your spot at ICETMCP-2026 (Edition 2)
          </p>
        </header>

        {/* Registration Fees Table */}
        <section className={styles.pricingSection}>
          <h2 className={styles.sectionTitle}>Registration Fee</h2>
          <table className={styles.feesTable}>
            <thead>
              <tr>
                <th>Category</th>
                <th>Indian Authors (INR)</th>
                <th>Foreign Authors (USD)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Industry Delegates</td>
                <td>₹5,000</td>
                <td>$200</td>
              </tr>
              <tr>
                <td>Academicians</td>
                <td>₹2,500</td>
                <td>$150</td>
              </tr>
              <tr>
                <td>Research Scholars</td>
                <td>₹2,000</td>
                <td>$120</td>
              </tr>
              <tr>
                <td>Students (UG/PG)</td>
                <td>₹1,250</td>
                <td>$100</td>
              </tr>
            </tbody>
          </table>
        </section>

        {/* Payment Methods */}
        <h2 className={styles.sectionTitle}>Payment Methods</h2>
        <section className={styles.paymentSection}>
          <div className={styles.paymentMethod}>
            <div className={styles.paymentTitle}>
              <CreditCard size={28} className={styles.icon} />
              <h3 style={{ whiteSpace: "nowrap" }}>Bank Transfer</h3>
            </div>

            <div style={{ marginTop: "20px" }}>
              <p><strong>Account Number:</strong> 11841100000354</p>
              <p><strong>Name:</strong> Genesys Research and AI Labs</p>
              <p style={{whiteSpace:'nowrap'}} className={styles.nowrapText}><strong>Bank Name:</strong> Punjab and Sind Bank (PSB)</p>
              <p><strong>IFSC Code:</strong> PSIB0021184</p>
              <p><strong>Branch Code:</strong> 021184</p>
              <p><strong>SWIFT Code:</strong> PSIBINBB</p>
              <p><strong>Branch:</strong> Pondicherry</p>
            </div>
          </div>

          <div className={styles.paymentMethod}>
            <div className={styles.paymentTitle}>
              <Smartphone size={28} className={styles.icon} />
              <h3 style={{ whiteSpace: "nowrap" }}>Digital Payment</h3>
            </div>
            <div className={styles.paymentMethodContent}>
              {/* <p><strong>GPay/PhonePe:</strong> 9677583754</p> */}
              <p><strong>Name:</strong> GENESYS ACADEMY</p>
              {/* <p><strong>UPI ID:</strong> uthayakumar17691-4@okhdfcbank</p> */}
              <p style={{ fontWeight: "bold", marginTop: "3px" }}>QR Code : Scan & Pay</p>
              <img src={qr} alt="QR Code"/>
            </div>
          </div>
        </section>

        {/* Important Payment Instructions */}
        <section className={styles.instructionsSection}>
          <h2 className={styles.sectionTitle}>Important Payment Instructions</h2>
          <ul className={styles.instructionsList}>
            <li>
              <strong className={styles.top}>Payment Reference:</strong>
              Please mention "Your Name" and "Accepted Paper ID"
              (e.g., Kaushik-ICETMCP027) in the remark/comment field.
            </li>
            <li><strong>Registration Deadline:</strong> 10 December, 2026</li>
            <li><strong>Refund Policy:</strong> Cancellation/refund of the conference fee after registration is not permitted.</li>
            <li><strong>Confirmation:</strong> You will receive a confirmation email after successful payment.</li>
          </ul>
        </section>
      </div>
    </div>
  );
}
